import { useState, useContext, useEffect } from "react";
import { Menu } from "antd";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/Team Intelligence Hub.svg";
import lang from "../../helper/lang";
import DashboardIcon from "../../assets/images/sidenavicon/dashbord-icon.svg";
import FacilitatorIcon from "../../assets/images//sidenavicon/master-facaltior-icon.svg";
import PractitionerIcon from "../../assets/images//sidenavicon/certified-icon.svg";
import SurveyIcon from "../../assets/images//sidenavicon/survey-icon.svg";
import CertificateIcon from "../../assets/images//sidenavicon/certificate-icon.svg";
import PricingIcon from "../../assets/images//sidenavicon/prising-icon.svg";
import TransactionIcon from "../../assets/images//sidenavicon/transication-icon.svg";
import ContentIcon from "../../assets/images//sidenavicon/content-icon.svg";
import FollowUpIcon from "../../assets/images//sidenavicon/side_nav/follow-tq-icon.svg";
import FoundationsIcon from "../../assets/images//sidenavicon/tps-funds-icon.svg";
import FollowUpTeamIcon from "../../assets/images//sidenavicon/follow-up-tq-lead-icon.svg";
import TpsLeadersIcon from "../../assets/images/sidenavicon/side_nav/tps-leaders-icon.svg";
import FollowTpsFoundationIcon from "../../assets/images/sidenavicon/side_nav/follow-up-TPS-foundations.svg";


const { SubMenu } = Menu;

export const menuItems = [
  {
    key: "Dashboard",
    path: "/dashboard",
    image: DashboardIcon,
    label: lang("Dashboard"),
  },
  {
    key: "MasterFacilitator",
    path: "/master-facilitator",
    image: FacilitatorIcon,
    label: lang("Master Facilitators"),
  },
  {
    key: "CertifiedPractioner",
    path: "/certified-practitioner",
    image: PractitionerIcon,
    label: lang("Certified Practitioners"),
  },
  {
    key: "Codes Management",
    path: "/codes",
    image: PricingIcon,
    label: lang("Codes Management"),
  },
  {
    key: "Survey",
    path: "/survey",
    image: SurveyIcon,
    label: lang("Surveys & Reports"),
  },
  // {
  //   key: "Tps Team Survey",
  //   path: "/tq-team-servey",
  //   image: SurveyIcon,
  //   label: lang("Tps Team Survey"),
  // },
  // {
  //   key: "Follow-up Team Survey",
  //   path: "/follow-up-surveys",
  //   image: FollowUpIcon,
  //   label: lang("Follow-up Team Survey"),
  // },
  // {
  //   key: "Tps for leaders",
  //   path: "/tqforleader",
  //   image: TpsLeadersIcon,
  //   label: lang("Tps for leaders"),
  // },
  // {
  //   key: "Follow Up TPS for Leaders",
  //   label: `Follow Up TPS for Leaders`,
  //   image: FollowUpTeamIcon,
  //   path: "/followupforleaderform",
  // },

  // {
  //   key: "TPS Foundations",
  //   path: "/tpsfoundations",
  //   image: FoundationsIcon,
  //   label: "Tps Foundations",
  // },
  // {
  //   key: "followuptpsfoundations",
  //   path: "/followuptpsfoundations",
  //   image: FollowTpsFoundationIcon,
  //   label: "Follow Up TPS Foundations",
  // },
  // {
  //   key: "Certificate Management",
  //   path: "/certificate-management",
  //   image: CertificateIcon,
  //   label: lang("Certificate Templates"),
  // },
  {
    key: "Pricing Management",
    path: "/pricing-management",
    image: PricingIcon,
    label: lang("Pricing Management"),
  },
  {
    key: "Transacation Manager",
    path: "/transaction",
    image: TransactionIcon,
    label: lang("Transactions"),
  },
  {
    key: "ContentManager",
    path: "/content-manager",
    image: ContentIcon,
    label: lang("Content Manager"),
  },
  {
    key: "Email Template",
    path: "/email-template",
    image: ContentIcon,
    label: lang("Email Template"),
  },
];

function Sidenav({ color, onItemClick }) {
  // Fallback to localStorage
  const userProfile = JSON.parse(localStorage.getItem("userProfile")) || {};
  const userPermission = userProfile?.roleId?.permission || [];

  const type = userProfile?.type || "";

  const permissionMap = userPermission.reduce((acc, item) => {
    acc[item.name] = item;
    return acc;
  }, {});

  const filteredMenuItems = menuItems.filter((item) => {
    const permission = permissionMap[item.key];
    if (type === "Admin") return true;
    if (!permission) return true;
    return !!permission.view;
  });

  return (
    <>
      <div className="brand">
        <Link to="/dashboard">
          <img src={logo} alt="" />
        </Link>
      </div>
      <Menu
        inlineCollapsed={false}
        mode="inline"
        className="sideNavMain"
        onClick={(e) => {
          // Optionally handle navigation here
          if (onItemClick) onItemClick(); // 👈 Close drawer
        }}
      >
        {filteredMenuItems.map((item) =>
          item.children ? (
            <Menu.SubMenu
              key={item.key}
              title={
                <>
                  <span className="icon">
                    <img src={item.image} alt="icon" />
                    <img src={item.image} />
                  </span>
                  <span className="label">{item.label}</span>
                </>
              }
            >
              {item.children.map((child) => (
                <Menu.Item key={child.key}>
                  <NavLink to={child.path}>
                    {/* <span className="icon">
                      <i className={child.icon}></i>
                    </span> */}
                    <span className="label">{child.label}</span>
                  </NavLink>
                </Menu.Item>
              ))}
            </Menu.SubMenu>
          ) : (
            <Menu.Item key={item.key}>
              <NavLink to={item.path}>
                <span className="icon">
                  <img src={item.image} />
                </span>
                <span className="label">{item.label}</span>
              </NavLink>
            </Menu.Item>
          )
        )}
      </Menu>
    </>
  );
}

export default Sidenav;
